import PropTypes from 'prop-types';
export default PropTypes.shape({
  UserAttributes: PropTypes.shape({
    email: PropTypes.string,
  }),
})